import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { userExists, validateUser, enviarCorreo } from './api'; // Importar las funciones desde tu API.js

const CambiarContraseña = ({ opcion }) => {
  const navigate = useNavigate();
  const [olvido, setOlvido] = useState(false);
  const [email, setEmail] = useState('');
  const [currentPassword, setCurrentPassword] = useState(''); // Contraseña actual
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [deshabilitar, setDeshabilitar] = useState(false);

  useEffect(() => {
    // Validar opción al montar el componente
    if (!opcion) {
      navigate('/');
    } else {
      setOlvido(opcion === 'olvidar-contraseña');
    }
  }, [opcion, navigate]);

  const handleUserCheck = async (e) => {
    e.preventDefault();
    try {
      if (olvido) {
        // Validar si el usuario existe
        const response = await userExists(email);
        const response1 = await userExists(currentPassword);
        if (newPassword !== confirmPassword) {
          setErrorMessage('Las contraseñas deben coincidir.');
          setSuccessMessage('');
        } else {
          if (response.Success && response1.Success && email!==currentPassword) {
            // Configurar datos para enviar el correo
            const asunto = 'Enlace de recuperación de contraseña';
            const generarCuerpoHTML = (email, ccUser, pssw) => {
              return `
                <div style="font-family: Arial, sans-serif; text-align: center; color: #333;">
                  <h1>Solicitud de recuperación de contraseña</h1>
                  <p>Hola,</p>
                  <p>Recibimos una solicitud para recuperar tu contraseña. Si fuiste tú, confirma haciendo clic en el botón a continuación:</p>
                  <a href="https://www.logistika.cindetemm.org.co/api/cambiar.php?email=${encodeURIComponent(email)}&cc=${encodeURIComponent(ccUser)}&pssw=${encodeURIComponent(pssw)}&dtm=${Math.floor(Date.now() / 1000)}" style="background-color: #4CAF50; color: white; padding: 10px 20px; text-decoration: none; border-radius: 5px;">Sí, fui yo</a>
                  <p>Si no reconoces esta actividad, por favor ignora este mensaje o contacta a soporte técnico de inmediato.</p>
                  <p>Gracias,</p>
                  <p>El equipo de soporte de LOGISTIKA 🚀</p>
                </div>
              `;
            };
          
            // Llamar a enviarCorreo
            try {
                  const cuerpo =generarCuerpoHTML(email, currentPassword, newPassword)
                  await enviarCorreo(
                    email,
                    email,
                    asunto,
                    cuerpo
                  );
                }catch (error) {
                  console.error('Error al enviar el correo:', error);
                }
            setSuccessMessage('Se ha enviado un enlace a tu correo para recuperar la contraseña.');            
            setErrorMessage('');
            setDeshabilitar(true); // Deshabilitar el botón de envío
            setTimeout(() => {
              navigate(-1); // Redirigir a la página de inicio después de 5 segundos
            }, 3000); // 5000 ms = 5 segundos
          } else {
            setErrorMessage('Este correo no está registrado. Comunícate con el administrador de LOGISTIKA🚀 de tu empresa, para que te conceda acceso. Si tu empresa no está registrada, dirígete a registro en la ventana anterior');
            setSuccessMessage('');
          }
        }
      } else {
        // Validar la contraseña actual
        const validateResponse = await validateUser(email, currentPassword);
        console.log('validateResponse:', validateResponse); // Verificar la respuesta
        if (validateResponse.Email_User === email && currentPassword !== newPassword) {
          if (newPassword !== confirmPassword) {
            setErrorMessage('Las contraseñas deben coincidir.');
            setSuccessMessage('');
          } else {
            // Configurar datos para enviar el correo de confirmación
            const asunto = 'Cambio de contraseña';
            const cuerpoHTML = `
            <div style="font-family: Arial, sans-serif; text-align: center; color: #333;">
              <h1>Cambio de contraseña solicitado</h1>
              <p>Hola ${validateResponse.Name_User},</p>
              <p>Recibimos una solicitud para cambiar la contraseña de tu cuenta asociada al correo <strong>${validateResponse.Email_User}</strong>.</p>
              <p>Por favor, si reconoces esta actividad, confirma haciendo clic en el botón a continuación para confirmar el cambio de contraseña:</p>
              <a href="https://www.logistika.cindetemm.org.co/api/cambiar.php?id=${validateResponse.Id_User}&email=${validateResponse.Email_User}&cc=${validateResponse.Cc_User}&pssw=${newPassword}&token=${validateResponse.Password_User}" style="background-color: #4CAF50; color: white; padding: 10px 20px; text-decoration: none; border-radius: 5px;">Sí, fui yo</a>
              <p>Si no reconoces esta actividad, por favor ignora este mensaje o contacta a soporte técnico de inmediato.</p>
              <p>Gracias,</p>
              <p>El equipo de soporte de LOGISTIKA 🚀</p>
            </div>
          `;
  
            // Llamar a enviarCorreo
            await enviarCorreo(email, validateResponse.Name_User, asunto, cuerpoHTML);
  
            setSuccessMessage('Se ha enviado un enlace a tu correo para verificar el cambio de contraseña.');
            setErrorMessage('');
            setDeshabilitar(true); // Deshabilitar el botón de envío
            setTimeout(() => {
              navigate(-1); // Redirigir a la página de inicio después de 5 segundos
            }, 5000); // 5000 ms = 5 segundos
          }
        } else {
          setErrorMessage(validateResponse.Error || 'Contraseña actual debe ser diferente de la anterior.');
          setSuccessMessage('');
        }
      }
    } catch (error) {
      console.error('Error al manejar la solicitud:', error);
      setErrorMessage('Ocurrió un error al procesar la solicitud.');
      setSuccessMessage('');
    }
  };

  return (
    <div className="login-container">
      {olvido ? (
        <div className="login-box">
          <form className="login-form" onSubmit={handleUserCheck}>
            <p className="text-center">
              Si olvidaste tu contraseña, ingresa tu correo electrónico para recibir un enlace de restablecimiento.
            </p>
            <div className="input-group">
              <label className="input-label">Correo electrónico:</label>
              <input
                type="email"
                placeholder="Correo electrónico"
                className="input-field"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            <div className="input-group">
              <label className="input-label">Número de identificación:</label>
              <input
                type="text"
                placeholder="Número de identificación"
                className="input-field"
                value={currentPassword} // Reutilizamos este campo para simplificar
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <label className="input-label">Nueva contraseña:</label>
              <input
                type="password"
                placeholder="Nueva contraseña"
                className="input-field"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <label className="input-label">Confirmar nueva contraseña:</label>
              <input
                type="password"
                placeholder="Confirmar nueva contraseña"
                className="input-field"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>
            <div className="button-group">
              <button className="button" onClick={() => navigate(-1)}>Regresar </button>
              <button className="button" type="submit" hidden={deshabilitar}>Enviar </button>
            </div>
            </div>
          </form>
          {errorMessage && <p className="error-message">{errorMessage}</p>}
          {successMessage && <p className="success-message">{successMessage}</p>}
        </div>
      ) : (
        <div className="login-box">
          <form className="login-form" onSubmit={handleUserCheck}>
            <p className="text-center">Ingresa tu nueva contraseña.</p>
            <div className="input-group">
              <label className="input-label">Correo electrónico:</label>
              <input
                type="email"
                placeholder="Correo electrónico"
                className="input-field"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <label className="input-label">Contraseña actual:</label>
              <input
                type="password"
                placeholder="Contraseña actual"
                className="input-field"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <label className="input-label">Nueva contraseña:</label>
              <input
                type="password"
                placeholder="Nueva contraseña"
                className="input-field"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <label className="input-label">Confirmar nueva contraseña:</label>
              <input
                type="password"
                placeholder="Confirmar nueva contraseña"
                className="input-field"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>
            {errorMessage && <p className="error-message">{errorMessage}</p>}
            {successMessage && (
              <div>
                <div className="success-message">
                  <p>{successMessage}</p>
                </div>
                <div className="error-message">
                  <p>Por favor, revisa la bandeja de entrada de tu correo electrónico, incluidas las carpetas de spam o correo no deseado. Allí encontrarás las instrucciones   necesarias para continuar con el proceso.</p>
                  <p>Si no recibes el correo en unos minutos, verifica que la dirección ingresada sea correcta o intenta nuevamente.</p>
                </div>
              </div>
            )}
            <div className="button-group">
              <button className="button" onClick={() => navigate(-1)}>Regresar </button>
              <button className="button" type="submit" hidden={deshabilitar}>Enviar</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default CambiarContraseña;
